/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Map: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path d='M23.6 1.2C23.4 1 23 1 22.7 1L17 2.7V22.8L23.3 21C23.7 20.9 24 20.5 24 20V2C24 1.7 23.9 1.4 23.6 1.2Z' fill='currentColor' />
    <path d='M15 2.7002L9 1.2002V21.3002L15 22.8002V2.7002Z' fill='currentColor' />
    <path
      d='M7 1.2002L0.7 3.0002C0.3 3.2002 0 3.6002 0 4.0002V22.0002C0 22.3002 0.1 22.6002 0.4 22.8002C0.6 22.9002 0.8 23.0002 1 23.0002C1.1 23.0002 1.2 23.0002 1.3 23.0002L7 21.3002V1.2002Z'
      fill='currentColor'
    />
  </React.Fragment>
)
